export const priority = {
    topBar: 100,
    bottomBar: 104,
    overlapBottomBar: 105,
}

export const RECENTLY_PLAYED_GAMES_AMOUNT = 10
